import { EmptyState, Icons, Heading } from "@ir/ui";

const DeductionNotfound = () => {
  return (
    <EmptyState
      className="bg-white border-1 border-color-grey-25 px-4 py-5 m-2"
      icon={Icons.InfoOctagon}
      title={
        <Heading level={6} className="text-grey-700 font-bold mt-3">
          No Deduction Found
        </Heading>
      }
    />
  );
};

export default DeductionNotfound;
